import { MapperBase } from '../../utilities/mapper-base';
import { IssueResource } from '../resource/issue.resource';
import { Issue } from '../ui/issue.model';
import { FactResourceToFactMapper } from './fact-resource-to-fact.mapper';

const mapper = new FactResourceToFactMapper();

export class IssueResourceToIssueMapper extends MapperBase<IssueResource, Issue> {
	map(source: IssueResource): Issue {
		const dest = new Issue();
		dest.id = source.issueId;
		dest.title = source.issueTitle;
		dest.description = source.description;
		dest.caseId = source.caseId;
		dest.facts = mapper.mapCollection(source?.facts) || [];
		return dest;
	}
}


